import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=d55ef710&scoped=true&"
import script from "./LeadsList.vue?vue&type=script&lang=js&"
export * from "./LeadsList.vue?vue&type=script&lang=js&"
import style0 from "./LeadsList.vue?vue&type=style&index=0&id=d55ef710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55ef710",
  null
  
)

export default component.exports